import { Link, RouteComponentProps } from '@reach/router'
import classNames from 'classnames'
import moment from 'moment'
import 'moment/locale/it'
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { DayModifiers } from 'react-day-picker'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import 'react-day-picker/lib/style.css'
import MomentLocaleUtils from 'react-day-picker/moment'
import { FaCheckCircle } from 'react-icons/fa'
import { FiFileText } from 'react-icons/fi'
import ReactModal from 'react-modal'
import { useBlockLayout, useFilters, useSortBy, useTable } from 'react-table'
import { VariableSizeList } from 'react-window'

import { FiDownload } from 'react-icons/fi'
import { useDispatch, useSelector } from 'react-redux'
import useGeneraSolleciti, { Tipologia } from '../../apiHooks/mutations/useGeneraSolleciti'
import useAvvisiPagamentoInsoluti from '../../apiHooks/queries/useAvvisiPagamentoInsoluti'
import useGruppoSolleciti from '../../apiHooks/queries/useGruppoSolleciti'
import useServizi from '../../apiHooks/queries/useServizi'
import Loading from '../../components/Loading'
import Price from '../../components/Price'
import { API_URL } from '../../config'
import AnnoScolasticoContext from '../../context/AnnoScolasticoContext'
import ServizioContext from '../../context/ServizioContext'
import shortenText from '../../lib/shortenText'
import { setAvvisiPagamento } from '../../redux/modules/insoluti'

const MONTHS = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre',
]
const WEEKDAYS_LONG = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']
const WEEKDAYS_SHORT = ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa']

const modalCustomStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    padding: 0,
    border: 'none',
  },
  overlay: {
    backgroundColor: 'hsla(207, 40%, 60%, 0.7)',
  },
}

const PagamentiSolleciti: React.FC<RouteComponentProps> = () => {
  //==================
  // REF
  //==================
  const tableRef = useRef<VariableSizeList>(null)

  //==================
  // CONTEXT
  //==================
  const { annoScolastico } = useContext(AnnoScolasticoContext)
  const { servizioId } = useContext(ServizioContext)
  const canGenerateRaccomandate = servizioId === 3

  const anni: string[] = annoScolastico.split('-')
  const dataMin = `${anni[0]}-09-01`
  const dataMax =
    (parseInt(anni[0], 10) === moment().year() && moment().month() >= 8) ||
    (parseInt(anni[1], 10) === moment().year() && moment().month() < 8)
      ? moment().endOf('month').format('YYYY-MM-DD')
      : `${anni[1]}-08-31`

  //==================
  // USE STATE
  //==================
  const [dataSel, setDataSel] = useState<string>(dataMax)
  const [dataSelDal, setDataSelDal] = useState<string>(dataMin)
  // const [rowsIdsSel, setRowsIdsSel] = useState<any>([])
  const [dataSollecito, setDataSollecito] = useState(moment().format('YYYY-MM-DD'))
  // const [avvisoSel, setAvvisoSel] = useState<any>(null)
  const [generaSollecitiModal, setGeneraSollecitiModal] = useState(false)
  const [tipologiaGenerazione, setTipologiaGenerazione] = useState<Tipologia>('solleciti')

  const dispatch = useDispatch()

  const { data: gruppoSolleciti } = useGruppoSolleciti()
  const { data: servizi } = useServizi()
  const currentServizio = servizi?.find((ser: any) => ser.id === servizioId)

  //==================
  // QUERIES
  //==================

  const { data: avvisiPagamento, isLoading: isLoadingAvvisiPagamento } = useAvvisiPagamentoInsoluti(
    {
      servizioId,
      emessiDa: dataSelDal,
      emessiA: dataSel,
    }
  )

  //==================
  // EFFECTS
  //==================

  useEffect(() => {
    if (avvisiPagamento) {
      dispatch(setAvvisiPagamento(avvisiPagamento))
      // dispatch(
      //   filterAvvisiPagamento({
      //     daData: !!dataSelDal ? dataSelDal : dataMin,
      //     aData: dataSel,
      //   })
      // )
    }
  }, [dataSel, dataSelDal, avvisiPagamento, dispatch, dataMin])

  const filteredAvvisiPagamento = useSelector((state: any) => {
    return state.insoluti.filteredAvvisiPagamento
  })
  //==================
  // MUTATIONS
  //==================
  const generaSolleciti = useGeneraSolleciti()

  //==================
  // CALLBACKS
  //==================
  const handleDayChange = useCallback(
    (day: Date, modifiers: DayModifiers, dayPickerInput: DayPickerInput) => {
      setDataSel(moment(day).format('YYYY-MM-DD'))
    },
    [setDataSel]
  )

  const handleDayChangeDal = useCallback(
    (day: Date, modifiers: DayModifiers, dayPickerInput: DayPickerInput) => {
      setDataSelDal(moment(day).format('YYYY-MM-DD'))
    },
    [setDataSelDal]
  )

  // const handleRowsChecking = useCallback(
  //   (rowId) => {
  //     let rowsIdsToSave = rowsIdsSel
  //     if (rowsIdsSel.indexOf(rowId) !== -1) {
  //       // RIMUOVI ROW SE GIÀ PRESENTE NELL'ARRAY
  //       rowsIdsToSave = rowsIdsSel.filter((r: any) => r !== rowId)
  //     } else {
  //       // AGGIUNGI ROW SE NON È PRESENTE NELL'ARRAY
  //       rowsIdsToSave = [...rowsIdsSel, rowId]
  //     }
  //     setRowsIdsSel(rowsIdsToSave)
  //   },
  //   [rowsIdsSel]
  // )

  // const handleGeneraSolleciti = useCallback(
  //   (numeroSollecito: number) => {
  //     // console.log(rowsIdsSel, numeroSollecito, dataSollecito)
  //     const sollecitiToSave = {
  //       avvisiPagamento: rowsIdsSel,
  //       livello: numeroSollecito,
  //       dataSollecito,
  //     }
  //     generaSolleciti.mutate({ servizioId, solleciti: sollecitiToSave })
  //   },
  //   [generaSolleciti, servizioId, rowsIdsSel, dataSollecito]
  // )

  // const getLabelPagamentoByValue = useCallback((value: string) => {
  //   switch (value) {
  //     case 'bon':
  //       return 'Bonifico'
  //     case 'sdd':
  //       return 'SDD'
  //     case 'cont':
  //       return 'Contanti'
  //     default:
  //       return ''
  //   }
  // }, [])

  //==================
  // REACT TABLE
  //==================
  const data = useMemo(() => filteredAvvisiPagamento || [], [filteredAvvisiPagamento])

  const sddFilter = (props: any) => {
    const { filterValue, setFilter } = props.column
    return (
      <input
        type="checkbox"
        checked={filterValue || false}
        onChange={(e) => {
          setFilter(e.target.checked || undefined)
        }}
        className="form-checkbox p-1"
      />
    )
  }

  const columns = useMemo(
    () => [
      {
        Header: 'N°',
        Footer: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3 bg-gray-100 text-blue-800 border-t border-gray-500">
              &nbsp;
            </div>
          )
        },
        accessor: 'numeroAvvisoPagamento',
        width: 45,
        disableFilters: true,
        Cell: (props: any) => {
          return <div className="h-full flex justify-start items-center p-3">{props.value}</div>
        },
      },
      {
        Header: 'Codice',
        Footer: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3 bg-gray-100 text-blue-800 border-t border-gray-500">
              &nbsp;
            </div>
          )
        },
        accessor: 'codiceBarre',
        width: 110,
        Cell: (props: any) => {
          return <div className="h-full flex justify-start items-center p-3">{props.value}</div>
        },
      },
      {
        Header: 'Scuola',
        Footer: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3 bg-gray-100 text-blue-800 border-t border-gray-500">
              &nbsp;
            </div>
          )
        },
        accessor: 'scuolaNome',
        width: 200,
        Cell: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3 text-xs">
              {shortenText(props.value, 70)}
            </div>
          )
        },
      },
      {
        Header: 'Cognome e nome',
        Footer: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3 bg-gray-100 text-blue-800 border-t border-gray-500">
              &nbsp;
            </div>
          )
        },
        accessor: 'bambinoCognome',
        width: 210,
        Cell: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3">
              <Link
                className="text-blue-500 hover:text-blue-600"
                to={`/app/anagrafica/alunno/${props.row.original.bambinoCodice}/servizio/${servizioId}`}
              >
                {props.value} {props.row.original.bambinoNome}
              </Link>
            </div>
          )
        },
      },
      {
        Header: 'SDD',
        Filter: sddFilter,
        Footer: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3 bg-blue-100 text-blue-800 border-t border-gray-500">
              &nbsp;
            </div>
          )
        },
        accessor: 'pagamentoSdd',
        width: 40,
        Cell: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3">
              {!!props.value ? <FaCheckCircle className="text-green-400" /> : null}
            </div>
          )
        },
      },
      // {
      //   Header: 'Importo',
      //   Footer: (props: any) => {
      //     const total = useMemo(
      //       () =>
      //         props.rows.reduce(
      //           (sum: any, row: any) => sum + parseFloat(row.values.importoTotale),
      //           0
      //         ),
      //       [props.rows]
      //     )

      //     return (
      //       <div className="h-full flex justify-end items-center p-3 font-semibold bg-blue-100 text-blue-800 border-t border-gray-500">
      //         <Price amount={total || 0} />
      //       </div>
      //     )
      //   },
      //   accessor: 'importoTotale',
      //   width: 100,
      //   disableFilters: true,
      //   Cell: (props: any) => {
      //     return (
      //       <div
      //         className={classNames('h-full flex justify-end items-center p-3 text-sm', {
      //           'text-gray-500': !props.value || props.value === '0.00',
      //         })}
      //       >
      //         <Price amount={props.value || 0} />
      //       </div>
      //     )
      //   },
      // },
      {
        Header: 'Q. genitore',
        Footer: (props: any) => {
          const total = useMemo(
            () =>
              props.rows.reduce(
                (sum: any, row: any) => sum + parseFloat(row.values.quotaCaricoGenitore),
                0
              ),
            [props.rows]
          )

          return (
            <div className="h-full flex justify-end items-center p-3 font-semibold bg-gray-100 text-blue-800 border-t border-gray-500">
              <Price amount={total || 0} />
            </div>
          )
        },
        accessor: 'quotaCaricoGenitore',
        width: 100,
        disableFilters: true,
        Cell: (props: any) => {
          return (
            <div
              className={classNames('h-full flex justify-end items-center p-3 text-sm', {
                'text-gray-500': !props.value || props.value === '0.00',
              })}
            >
              <Price amount={props.value || 0} />
            </div>
          )
        },
      },
      {
        Header: 'Pagato',
        Footer: (props: any) => {
          const total = useMemo(
            () =>
              props.rows.reduce(
                (sum: any, row: any) => sum + parseFloat(row.values.importoPagato),
                0
              ),
            [props.rows]
          )

          return (
            <div className="h-full flex justify-end items-center p-3 font-semibold bg-gray-100 text-blue-800 border-t border-gray-500">
              <Price amount={total || 0} />
            </div>
          )
        },
        accessor: 'importoPagato',
        width: 100,
        disableFilters: true,
        Cell: (props: any) => {
          return (
            <div
              className={classNames(
                'h-full flex justify-end items-center p-3 text-sm',
                {
                  'text-green-500 font-semibold':
                    parseFloat(props.value) >= parseFloat(props.row.original.quotaCaricoGenitore),
                },
                {
                  'text-red-600':
                    parseFloat(props.value) < parseFloat(props.row.original.quotaCaricoGenitore),
                }
              )}
            >
              <Price amount={props.value || 0} />
            </div>
          )
        },
      },
      {
        Header: 'Periodo',
        Footer: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3 bg-gray-100 text-blue-800 border-t border-gray-500">
              &nbsp;
            </div>
          )
        },
        accessor: 'periodo',
        width: 140,
        disableFilters: true,
        Cell: (props: any) => {
          return <div className="h-full flex items-center p-3">{props.value}</div>
        },
      },
      {
        Header: 'Scadenza',
        Footer: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3 bg-gray-100 text-blue-800 border-t border-gray-500">
              &nbsp;
            </div>
          )
        },
        accessor: 'dataScadenza',
        width: 100,
        disableFilters: true,
        Cell: (props: any) => {
          return (
            <div className="h-full flex items-center p-3">
              {moment(props.value, 'YYYY-MM-DD', true).format('DD/MM/YYYY')}
            </div>
          )
        },
      },
      {
        Header: ' ',
        Footer: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3 bg-blue-100 text-blue-800 border-t border-gray-500">
              &nbsp;
            </div>
          )
        },
        accessor: 'linkDownload',
        width: 40,
        disableFilters: true,
        disableSortBy: true,
        Cell: (props: any) => {
          return (
            <div className="h-full flex justify-start items-center p-3">
              <a
                className="bg-blue-500 focus:shadow-outline focus:outline-none text-white text-sm leading-5 py-1 px-1 rounded transition-colors duration-150 hover:bg-blue-700 hover:shadow-xl"
                href={`${props.value}?t=${encodeURIComponent(localStorage.getItem('token') || '')}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FiFileText />
              </a>
            </div>
          )
        },
      },
      // {
      //   Header: 'Note',
      //   Footer: (props: any) => {
      //     return (
      //       <div className="h-full flex justify-start items-center p-3 bg-gray-100 text-blue-800 border-t border-gray-500">
      //         &nbsp;
      //       </div>
      //     )
      //   },
      //   accessor: 'nota',
      //   width: 150,
      //   disableFilters: true,
      //   Cell: (props: any) => {
      //     return <div className="h-full flex items-center p-3 text-xs">{props.value}</div>
      //   },
      // },
    ],
    // [servizioId, handleRowsChecking, rowsIdsSel]
    [servizioId]
  )

  const columnFilter = (props: any) => {
    const {
      filterValue,
      // preFilteredRows,
      setFilter,
    } = props.column
    return (
      <input
        value={filterValue || ''}
        onChange={(e) => {
          setFilter(e.target.value || undefined)
        }}
        placeholder="Cerca..."
        // placeholder={`Cerca tra ${preFilteredRows.length} avvisi...`}
        className="form-input p-1 rounded text-xs w-24"
      />
    )
  }

  const defaultColumn = useMemo(
    () => ({
      Filter: columnFilter,
    }),
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    totalColumnsWidth,
    rows,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      // @ts-ignore
      defaultColumn,
    },
    useBlockLayout,
    useFilters,
    useSortBy
  )

  const rowHeights = useMemo(
    () =>
      rows.map((r: any) => {
        return 42
      }),
    [rows]
  )

  const getItemSize = useCallback(
    (index: number) => {
      return rowHeights[index]
    },
    [rowHeights]
  )

  const RenderRow = useCallback(
    ({ index, style }) => {
      const row = rows[index]
      prepareRow(row)
      return (
        <>
          <div
            {...row.getRowProps({
              style,
            })}
            className="tr hover:bg-blue-100 border-b border-gray-400"
          >
            <div className="flex items-center">
              {row.cells.map((cell) => {
                return (
                  <div
                    {...cell.getCellProps()}
                    className="td h-full overflow-y-hidden leading-none p-0"
                  >
                    {cell.render('Cell')}
                  </div>
                )
              })}
            </div>
          </div>
        </>
      )
    },
    [prepareRow, rows]
  )

  const handleGeneraSolleciti = (
    dataSollecito: string,
    daData: string,
    aData: string,
    tipologia: Tipologia
  ) => {
    if (tipologia === 'raccomandate' && !canGenerateRaccomandate) return
    setGeneraSollecitiModal(false)
    generaSolleciti.mutate({ servizioId, payload: { daData, aData, dataSollecito, tipologia } })
  }

  //==================
  // RETURN
  //==================
  return (
    <div className="bg-white py-6">
      <style>
        {`
        .ag-theme-alpine * {
          border-style: none;
        }
        .ag-react-container {
          height: 100%;
        }
      `}
      </style>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl leading-tight mb-4">Avvisi da sollecitare</h1>
        <div className="mb-2">
          Avvisi emessi dal{' '}
          <DayPickerInput
            formatDate={MomentLocaleUtils.formatDate}
            parseDate={MomentLocaleUtils.parseDate}
            format="LL"
            placeholder={`${MomentLocaleUtils.formatDate(
              moment(dataMin, 'YYYY-MM-DD', true).toDate(),
              'LL',
              'it'
            )}`}
            inputProps={{
              className: 'form-input p-2 text-xl text-blue-500 cursor-pointer border-0',
            }}
            dayPickerProps={{
              locale: 'it',
              localeUtils: MomentLocaleUtils,
              className: 'bg-white rounded py-2 px-2 shadow-lg border-gray-200',
              months: MONTHS,
              weekdaysLong: WEEKDAYS_LONG,
              weekdaysShort: WEEKDAYS_SHORT,
              firstDayOfWeek: 1,
              disabledDays: [
                {
                  before: moment(currentServizio?.dataPrimaEmissione).toDate(),
                },
              ],
            }}
            value={moment(dataMin).format('DD MMMM YYYY')}
            onDayChange={handleDayChangeDal}
          />{' '}
          al{' '}
          <DayPickerInput
            formatDate={MomentLocaleUtils.formatDate}
            parseDate={MomentLocaleUtils.parseDate}
            format="LL"
            placeholder={`${MomentLocaleUtils.formatDate(
              moment(dataSel, 'YYYY-MM-DD', true).toDate(),
              'LL',
              'it'
            )}`}
            inputProps={{
              className: 'form-input p-2 text-xl text-blue-500 cursor-pointer border-0',
            }}
            dayPickerProps={{
              locale: 'it',
              localeUtils: MomentLocaleUtils,
              className: 'bg-white rounded py-2 px-2 shadow-lg border-gray-200',
              months: MONTHS,
              weekdaysLong: WEEKDAYS_LONG,
              weekdaysShort: WEEKDAYS_SHORT,
              firstDayOfWeek: 1,
            }}
            value={moment(dataSel).format('DD MMMM YYYY')}
            onDayChange={handleDayChange}
          />
        </div>
        <div className="table-wrapper block max-w-full mb-12 overflow-x-scroll overflow-y-hidden">
          {!!filteredAvvisiPagamento && !isLoadingAvvisiPagamento && (
            <div
              {...getTableProps()}
              className="table w-full max-w-6xl text-sm border border-gray-400 rounded rounded-tr-none"
            >
              <div>
                {headerGroups.map((headerGroup) => (
                  <div {...headerGroup.getHeaderGroupProps()} className="tr">
                    {headerGroup.headers.map((column: any) => {
                      return (
                        <div
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                          className={classNames(
                            'th py-2 px-3 border-b border-gray-400 bg-gray-100 text-left text-gray-800 font-semibold',
                            {
                              'text-right':
                                column.Header === 'Importo' || column.Header === 'Pagato',
                            },
                            {
                              'text-center': column.Header === 'Soll.' || column.Header === 'N°',
                            }
                          )}
                        >
                          {column.render('Header')}
                          <span>
                            {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                          </span>
                          <div className="pt-2 w-full" onClick={(e) => e.stopPropagation()}>
                            {column.canFilter ? column.render('Filter') : null}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                ))}
              </div>
              <div {...getTableBodyProps()}>
                <VariableSizeList
                  ref={tableRef}
                  height={400}
                  itemCount={rows.length}
                  itemSize={getItemSize}
                  width={totalColumnsWidth}
                >
                  {RenderRow}
                </VariableSizeList>
              </div>
              {footerGroups.map((group) => (
                <div className="tr" {...group.getFooterGroupProps()}>
                  {group.headers.map((column) => (
                    <div className="td" {...column.getFooterProps()}>
                      {column.render('Footer')}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
          {isLoadingAvvisiPagamento && <Loading className="py-12" />}
        </div>
        {/* <div className="mb-6">Righe selezionate: {rowsIdsSel.length || 0}</div> */}
        <div className="flex space-x-6 items-end justify-between">
          <div className="flex space-x-3">
            <button
              type="button"
              className={classNames(
                gruppoSolleciti &&
                  !(gruppoSolleciti.status === 'completed' || gruppoSolleciti.status === 'error')
                  ? 'bg-gray-400 cursor-not-allowed text-white text-sm leading-5 py-2 px-5 rounded'
                  : 'focus:shadow-outline focus:outline-none text-white text-sm leading-5 py-2 px-5 rounded transition-colors duration-150 hover:shadow-xl bg-blue-500  hover:bg-blue-700 cursor-pointer'
              )}
              onClick={
                () => {
                  setTipologiaGenerazione('solleciti')
                  setGeneraSollecitiModal(true)
                }
                // handleGeneraSolleciti(
                //   dataSollecito,
                //   !!dataSelDal ? dataSelDal : currentServizio?.dataPrimaEmissione,
                //   dataSel
                // )
              }
              // disabled={rowsIdsSel.length < 1}
              disabled={
                gruppoSolleciti
                  ? gruppoSolleciti.status !== 'completed' && gruppoSolleciti.status !== 'error'
                  : false
              }
            >
              Genera solleciti
            </button>

            {canGenerateRaccomandate && (
              <button
                type="button"
                className={classNames(
                  gruppoSolleciti &&
                    !(gruppoSolleciti.status === 'completed' || gruppoSolleciti.status === 'error')
                    ? 'bg-gray-400 cursor-not-allowed text-white text-sm leading-5 py-2 px-5 rounded'
                    : 'focus:shadow-outline focus:outline-none text-white text-sm leading-5 py-2 px-5 rounded transition-colors duration-150 hover:shadow-xl bg-indigo-500 hover:bg-indigo-700 cursor-pointer'
                )}
                onClick={() => {
                  setTipologiaGenerazione('raccomandate')
                  setGeneraSollecitiModal(true)
                }}
                disabled={
                  gruppoSolleciti
                    ? gruppoSolleciti.status !== 'completed' && gruppoSolleciti.status !== 'error'
                    : false
                }
              >
                Genera raccomandate
              </button>
            )}

            {/* <a
              className="block bg-indigo-500 focus:shadow-outline focus:outline-none text-white leading-5 py-2 px-5 rounded transition-colors duration-150 hover:bg-indigo-600 hover:shadow-xl"
              href={`${API_URL}/gruppo-solleciti/zip-file?t=${encodeURIComponent(
                localStorage.getItem('token') || ''
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Report pagamenti
            </a> */}
          </div>
        </div>
        {gruppoSolleciti && (
          <div className="align-middle inline-block min-w-full overflow-hidden sm:rounded border border-gray-300 mt-12">
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Data sollecito
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Dal - Al
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Tipologia
                  </th>
                  {gruppoSolleciti.status !== 'completed' ? (
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th>
                  ) : (
                    <th className="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                      Download
                    </th>
                  )}
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-100 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"></th>
                </tr>
              </thead>
              <tbody className="bg-white">
                <tr className={'bg-white'}>
                  <td className="px-6 py-4 whitespace-nowrap border-b border-gray-200">
                    {moment(gruppoSolleciti.dataSollecito).format('DD/MM/YYYY')}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap border-b border-gray-200">
                    {moment(gruppoSolleciti.daData).format('DD/MM/YYYY')} -{' '}
                    {moment(gruppoSolleciti.aData).format('DD/MM/YYYY')}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap border-b border-gray-200">
                    {gruppoSolleciti.tipologia === 'raccomandate' ? 'Raccomandate' : 'Solleciti'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap border-b border-gray-200">
                    {gruppoSolleciti.status !== 'completed' ? (
                      <div
                        className={`${
                          gruppoSolleciti.status === 'error' &&
                          'bg-red-400 text-white w-1/2 text-center p-1 font-semibold'
                        }`}
                      >
                        {getStatoLabel(gruppoSolleciti.status)}
                      </div>
                    ) : (
                      <a
                        className="text-blue-500 hover:text-blue-600 flex items-center gap-4"
                        href={`${API_URL}/gruppo-solleciti/zip-file?t=${encodeURIComponent(
                          localStorage.getItem('token') || ''
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Scarica file <FiDownload />
                      </a>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* <ReactModal
        isOpen={!!avvisoSel}
        onRequestClose={() => {
          setAvvisoSel(null)
          document.getElementById('root')!.style.filter = 'blur(0)'
        }}
        style={modalCustomStyles}
      >
        <div className="max-w-lg">
          {!!avvisoSel && (
            <>
              <div className="bg-blue-500 text-white font-semibold py-2 text-center">
                Cronologia solleciti e pagamenti per
                <br />
                {avvisoSel.bambinoCognome} {avvisoSel.bambinoNome}
              </div>

              <div className="px-10 py-6">
                <p className="mb-4">
                  Importo dovuto:{' '}
                  <b>
                    <Price amount={avvisoSel.importoTotale} />
                  </b>{' '}
                  entro il{' '}
                  <b>{moment(avvisoSel.dataScadenza, 'YYYY-MM-DD', true).format('DD/MM/YYYY')}</b>
                </p>
                <div className="flex flex-col mb-8 bg-blue-100 border rounded border-blue-200 text-sm">
                  {avvisoSel.pagamenti.map((p: any) => {
                    return (
                      <div
                        key={p.id}
                        className="flex w-full items-center text-xs px-2 border-b  border-blue-200"
                      >
                        <div className="w-6 p-1">
                          {p.importo ? <FaCoins color="#fc0" /> : <FaForward />}
                        </div>
                        <div className="w-20 p-1">
                          {moment(p.data, 'YYYY-MM-DD', true).format('DD/MM/YYYY')}
                        </div>
                        <div className="w-20 p-1 text-right">
                          <Price amount={p.importo} />
                        </div>
                        <div className="w-20 p-1">{getLabelPagamentoByValue(p.tipo)}</div>
                        <div className="flex-1 p-1 leading-tight">{!!p.nota && `${p.nota}`}</div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </>
          )}
        </div>
      </ReactModal> */}

      <ReactModal
        isOpen={!!generaSollecitiModal}
        onRequestClose={() => {
          setGeneraSollecitiModal(false)
          document.getElementById('root')!.style.filter = 'blur(0)'
        }}
        style={modalCustomStyles}
      >
        <div className="max-w-lg p-6 flex flex-col justify-center items-center gap-6 w-80">
          <div className="mt-4">
            <label
              htmlFor="dataSollecito"
              className="block text-sm leading-5 font-medium text-gray-600 text-center"
            >
              Data di generazione del{' '}
              {tipologiaGenerazione === 'raccomandate' ? 'raccomandata' : 'sollecito'}:
            </label>

            <input
              className="mt-1 form-input w-full h-10"
              id="dataSollecito"
              name="dataSollecito"
              type="date"
              value={dataSollecito}
              onChange={(e) => setDataSollecito(e.target.value)}
            />
          </div>

          <div className="flex space-x-3 mb-4">
            <button
              type="button"
              className="focus:shadow-outline focus:outline-none text-white text-sm leading-5 py-2 px-5 rounded transition-colors duration-150 hover:shadow-xl bg-blue-500 hover:bg-blue-700 cursor-pointer"
              onClick={() =>
                handleGeneraSolleciti(
                  dataSollecito,
                  !!dataSelDal ? dataSelDal : dataMin,
                  dataSel,
                  tipologiaGenerazione
                )
              }
              disabled={!moment(dataSollecito).isValid()}
            >
              {tipologiaGenerazione === 'raccomandate' ? 'Genera raccomandate' : 'Genera solleciti'}
            </button>
          </div>
        </div>
      </ReactModal>
    </div>
  )
}

export default PagamentiSolleciti

export function getStatoLabel(stato: 'completed' | 'error' | 'started' | 'in_progress') {
  switch (stato) {
    case 'completed':
      return 'Completato'
    case 'error':
      return 'Errore'
    case 'in_progress':
      return (
        <div className="flex items-center gap-4">
          In corso <Loading size={20} />{' '}
        </div>
      )
    case 'started':
      return 'Avviato'
  }
}
